import { Form, FormField } from "@babackapp/ui/components/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import useTranslation from "@babackapp/translations/use-translation";
import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import {
  UpdateOneWorkflowDto,
  WorkflowDto,
} from "@babackapp/private-api-client/types";
import { Button } from "@babackapp/ui/components/button";

const formSchema = z.object({
  name: z.string(),
  description: z.string(),
});

type EditWorkflowFormValues = z.infer<typeof formSchema>;

type EditOneWorkflowProps = {
  defaultValues: z.infer<typeof formSchema>;
  onSubmit: (data: UpdateOneWorkflowDto) => Promise<WorkflowDto> | undefined;
  closeForm: () => void;
};

export default function EditWorkflowForm({
  defaultValues,
  onSubmit,
  closeForm,
}: EditOneWorkflowProps) {
  const t = useTranslation();

  const form = useForm<EditWorkflowFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  });

  const _onSubmit = form.handleSubmit((data) => {
    onSubmit(data);
  });

  return (
    <Form {...form}>
      <form
        onSubmit={_onSubmit}
        className="flex flex-col justify-start gap-8 mt-[16px]"
      >
        <FormInputRow>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormInput
                label={t("workflow.create.name")}
                {...field}
              />
            )}
          />
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormInput
                label={t("workflow.create.description")}
                {...field}
              />
            )}
          />
        </FormInputRow>

        <div className="flex justify-end gap-4">
          <Button
            variant={"outline"}
            onClick={closeForm}
            size={"lg"}
            className="w-1/2"
          >
            {t("misc.cancel")}
          </Button>
          <Button
            variant={"default"}
            disabled={!form.formState.isDirty}
            size={"lg"}
            type="submit"
            className="w-1/2"
          >
            {t("misc.update")}
          </Button>
        </div>
      </form>
    </Form>
  );
}
